/**
 * @desc 计算指定文件 md5
 * @type {object} File 要计算 md5 的文件
 */

import SparkMD5 from 'spark-md5'

export default (file, obj = {}) => {
  let fileReader = new FileReader()
  let blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,

    chunkSize = 1024 * 1024 * 2,
    chunks = Math.ceil(file.size / chunkSize),
    currentChunk = 0,

    spark = new SparkMD5.ArrayBuffer()

  function loadNext() {
    let start = currentChunk * chunkSize,
      end = start + chunkSize >= file.size ? file.size : start + chunkSize

    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
  }

  loadNext()

  return new Promise((resolve) => {

    fileReader.onload = function (e) {

      spark.append(e.target.result)
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        obj.filename = file.name
        obj.md5 = spark.end()

        resolve(obj)
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/lib/md5.js